import { type FormField } from '@wix/ambassador-forms-v4-form/types';

import { asRequired } from '../utils/lang';

export function isInputField(field: FormField): boolean {
  if (field.validation) {
    asRequired(field.target, field, 'target');
  }
  return Boolean(field.validation);
}

export function fieldHasTarget(field: FormField): boolean {
  return Boolean(field.target);
}
